<template>
  <div class="shopSearch">
    <search-result :pager="pager" :shops="shops" :pr_shops="pr_shops" :waiting="form.waiting" @next="search" />
  </div>
</template>

<script>
import SearchResult from './searchResult.vue';

export default {
    components: {
        'search-result': SearchResult
    },
    props: {
        prefecture: { 
            required: true,
            type: String
        },
        area: {
            required: false,
            type: Number
        },
        areaDetail: {
            required: false,
            type: Number,
            default: null
        },
        station: {
            required: false,
            type: Number,
            default: null
        },
        people_from: {
            required: false,
            type: Number,
            default: null
        },
        price_to: {
            required: false,
            type: Number,
            default: null
        },
        shopType: {
            required: false,
            type: Number,
            default: null
        }
    },
    data: function() {
      return {
        form: this.createForm({
            prefecture: this.prefecture,
            area: this.area,
            area_detail: this.areaDetail,
            station: this.station,
            people_from: this.people_from,
            price_to: this.price_to,
            shop_type: this.shopType,
        }),
        pager: this.createPager(20),
        shops: [],
        pr_shops: [],
      };
    },
    created: function() {
        this.search();
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.form.model.page = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;
            this.form.get('/api/shops', function(response) {
                this.shops = [];
                this.pr_shops = [];
                _.forEach(response.data['shops'], function(each) {
                    this.shops.push(each);
                }.bind(this));
                _.forEach(response.data['pr_shops'], function(each) {
                    this.pr_shops.push(each);
                }.bind(this));
                this.createItemListSchema();
                this.pager.update(response.data['shops'], response);
                this.$emit('shopsCount', this.pager.total);
                this.$emit('shops', this.shops);
            });
        },
        filteredShops() {
            const prShopIds = this.pr_shops.map(shop => shop.id);
            return this.shops.filter(shop => !prShopIds.includes(shop.id));
        },
        createItemListSchema: function() {
            const result_shops = this.pr_shops.concat(this.filteredShops());
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            const url = new URL(window.location.href);
            script.text = JSON.stringify({
                '@context': 'http://schema.org',
                '@type': 'ItemList',
                'itemListElement': result_shops.map((shop, index) => ({
                    '@type': 'ListItem',
                    'position': index + 1,
                    'url': `${url.protocol}//${url.hostname}${shop.detail_url}`,
                })),
            });
            head.appendChild(script);
        },
    }
}
</script>
